import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getProperty } from '@go-client/lib/api/property';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const StaffTemplateLog: React.FC<UserActionLog> = ({ body }) => {
  const { brand } = useServerInfo();
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        if (body.property) {
          const property = await getProperty(body.property);
          const propertyFields = FieldsReplacer(property, logFields, [
            {
              from: 'name',
              to: 'property',
            },
            {
              from: 'staffBerthings',
              to: 'berthing',
            },
          ]);

          const brandFields = FieldsReplacer(brand, logFields, [
            {
              from: 'staffDepartments',
              to: 'department',
            },
          ]);

          setLogFields({ ...logFields, ...propertyFields, ...brandFields });
        }
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
